var mapBlockLoaderPromise = null;
var mapBlockDefaultCenter = { lat: 52.28357516250211, lng: -1.8187719997599583 };
var mapBlockDefaultZoom = 7;
var $ = window.jQuery;

function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps) {
        return $.Deferred().resolve().promise();
    }

    if (mapBlockLoaderPromise) {
        return mapBlockLoaderPromise.promise();
    }

    mapBlockLoaderPromise = $.Deferred();

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey);
    script.onload = function () {
        mapBlockLoaderPromise.resolve();
    };
    script.onerror = function () {
        mapBlockLoaderPromise.reject(new Error('Google Maps could not be loaded.'));
    };

    document.head.appendChild(script);

    return mapBlockLoaderPromise.promise();
}

function getDataId(root, key) {
    return root.getAttribute('data-' + key);
}

function ajaxJson(url, data) {
    var deferred = $.Deferred();
    var query = [];

    for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key) && data[key] !== undefined && data[key] !== null) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
    }

    var requestUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + query.join('&');
    var request = new XMLHttpRequest();

    request.open('GET', requestUrl, true);
    request.setRequestHeader('Accept', 'application/json');
    request.onreadystatechange = function () {
        if (request.readyState !== 4) {
            return;
        }

        if (request.status >= 200 && request.status < 300) {
            try {
                deferred.resolve(JSON.parse(request.responseText));
            } catch (error) {
                deferred.reject(error);
            }
        } else {
            deferred.reject(new Error('Request failed with status ' + request.status));
        }
    };

    request.send(null);

    return deferred.promise();
}

function initMapBlockMap(mapElement) {
    return new google.maps.Map(mapElement, {
        center: mapBlockDefaultCenter,
        zoom: mapBlockDefaultZoom,
        disableDefaultUI: true,
        draggable: true,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        gestureHandling: 'auto',
        keyboardShortcuts: false,
        clickableIcons: false,
        styles: [
            { elementType: 'geometry', stylers: [{ color: '#def8db' }] },
            { elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#def8db' }] },
            { featureType: 'administrative', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', stylers: [{ visibility: 'off' }] },
            { featureType: 'transit', stylers: [{ visibility: 'off' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#ffffff' }] }
        ]
    });
}

function ClinicPinOverlay(position, map, name, url, labelPosition) {
    this.position = position;
    this.name = name;
    this.url = url;
    this.labelPosition = labelPosition || 'top';
    this.div = null;
    this.setMap(map);
}

function setUpClinicPinOverlayPrototype() {
    if (ClinicPinOverlay.prototype instanceof google.maps.OverlayView) {
        return;
    }

    ClinicPinOverlay.prototype = new google.maps.OverlayView();

    ClinicPinOverlay.prototype.onAdd = function () {
        var div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.width = '22px';
        div.style.height = '22px';
        div.style.transform = 'translate(-50%, -50%)';

        var label = document.createElement('span');
        label.textContent = this.name;
        label.style.position = 'absolute';
        label.style.color = '#000000';
        label.style.fontWeight = '700';
        label.style.fontSize = '13px';
        label.style.lineHeight = '1.2';
        label.style.whiteSpace = 'nowrap';
        label.style.textShadow = 'none';

        if (this.labelPosition === 'right') {
            label.style.left = 'calc(100% + 6px)';
            label.style.top = '50%';
            label.style.transform = 'translateY(-50%)';
        } else if (this.labelPosition === 'left') {
            label.style.right = 'calc(100% + 6px)';
            label.style.top = '50%';
            label.style.transform = 'translateY(-50%)';
        } else if (this.labelPosition === 'bottom') {
            label.style.left = '50%';
            label.style.top = 'calc(100% + 4px)';
            label.style.transform = 'translateX(-50%)';
        } else {
            label.style.left = '50%';
            label.style.bottom = 'calc(100% + 4px)';
            label.style.transform = 'translateX(-50%)';
        }

        var dot = document.createElement('span');
        dot.style.display = 'flex';
        dot.style.alignItems = 'center';
        dot.style.justifyContent = 'center';
        dot.style.width = '22px';
        dot.style.height = '22px';
        dot.style.borderRadius = '9999px';
        dot.style.border = '3px solid #ffffff';
        dot.style.backgroundColor = '#1B6445';
        dot.style.boxSizing = 'border-box';

        var innerDot = document.createElement('span');
        innerDot.style.width = '8px';
        innerDot.style.height = '8px';
        innerDot.style.borderRadius = '9999px';
        innerDot.style.backgroundColor = '#1B6445';
        dot.appendChild(innerDot);

        div.appendChild(dot);
        div.appendChild(label);

        if (this.url) {
            div.style.cursor = 'pointer';
            div.addEventListener('click', function (url) {
                return function () {
                    window.location.href = url;
                };
            }(this.url));
        }

        this.div = div;
        this.getPanes().overlayMouseTarget.appendChild(div);
    };

    ClinicPinOverlay.prototype.draw = function () {
        if (!this.div) {
            return;
        }

        var position = this.getProjection().fromLatLngToDivPixel(this.position);
        this.div.style.left = position.x + 'px';
        this.div.style.top = position.y + 'px';
    };

    ClinicPinOverlay.prototype.onRemove = function () {
        if (this.div && this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
        }
        this.div = null;
    };
}

function normalizeMapBlockClinicName(name) {
    var value = (name || 'Clinic').replace(/^CREATE\s*/i, '').replace(/\s*NHS$/i, '').trim();
    return value || 'Clinic';
}

function getLabelPositionForClinic(clinic, placedClinics) {
    var latitude = clinic.Latitude || clinic.latitude;
    var longitude = clinic.Longitude || clinic.longitude;

    if (latitude === undefined || longitude === undefined || latitude === null || longitude === null) {
        return 'top';
    }

    var variants = ['top', 'right', 'left', 'bottom'];
    var nearbyCount = 0;

    for (var i = 0; i < placedClinics.length; i++) {
        var placed = placedClinics[i];
        var latDiff = Math.abs(placed.latitude - latitude);
        var lngDiff = Math.abs(placed.longitude - longitude);

        if (latDiff <= 0.6 && lngDiff <= 0.8) {
            nearbyCount++;
        }
    }

    return variants[nearbyCount % variants.length];
}

function initMapBlock(root) {
    var apiKey = getDataId(root, 'google-maps-api-key') || '';
    var endpointUrl = getDataId(root, 'endpoint') || '';
    var mapId = getDataId(root, 'map-id');
    var clinicIds = getDataId(root, 'clinic-ids') || '';
    var mapElement = document.getElementById(mapId);

    if (!mapElement || !endpointUrl) {
        return;
    }

    if (!apiKey && !(window.google && window.google.maps)) {
        return;
    }

    loadGoogleMaps(apiKey).done(function () {
        setUpClinicPinOverlayPrototype();

        var map = initMapBlockMap(mapElement);
        var overlays = [];

        ajaxJson(endpointUrl, {
            clinicIds: clinicIds
        }).done(function (clinics) {
            for (var i = 0; i < overlays.length; i++) {
                overlays[i].setMap(null);
            }
            overlays.length = 0;

            if (!clinics || !clinics.length) {
                return;
            }

            var placedClinics = [];

            for (var j = 0; j < clinics.length; j++) {
                var clinic = clinics[j];
                var latitude = clinic.Latitude || clinic.latitude;
                var longitude = clinic.Longitude || clinic.longitude;

                if (latitude === undefined || longitude === undefined || latitude === null || longitude === null) {
                    continue;
                }

                var position = new google.maps.LatLng(latitude, longitude);
                var labelPosition = getLabelPositionForClinic(clinic, placedClinics);
                var clinicName = normalizeMapBlockClinicName(clinic.Name || clinic.name || 'Clinic');

                overlays.push(new ClinicPinOverlay(position, map, clinicName, clinic.Url || clinic.url, labelPosition));
                placedClinics.push({ latitude: latitude, longitude: longitude });
            }
        });
    });
}

export function initMapBlocks() {
    if (!$) {
        return;
    }

    var mapRoots = document.querySelectorAll('[data-map-block="true"]');
    Array.prototype.forEach.call(mapRoots, function (root) {
        initMapBlock(root);
    });
}
